// Empty permissionKeys array means that the service URL will return to everyone independently of their permissions
const devServices = [
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKeys: [],
    },
    {
        id: "fpm",
        url: "https://fpm-dev.c12r.io",
        permissionKeys: ["fpm.access"],
    },
    {
        id: "fpc",
        url: "https://corporate-frontend.dev.c12r.io",
        permissionKeys: ["fpc.access"],
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-supplier.access"],
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-purchaser.access"],
    },
];
const stagingServices = [
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKeys: [],
    },
    {
        id: "fpm",
        url: "https://fpm-staging.c12r.io",
        permissionKeys: ["fpm.access"],
    },
    {
        id: "fpc",
        url: "https://corporate-frontend.stg.c12r.io",
        permissionKeys: ["fpc.access"],
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-supplier.access"],
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-purchaser.access"],
    },
    {
        id: "cfc",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.access"],
    },
    {
        id: "cfc.ccf-basic",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-basic.access"],
    },
    {
        id: "cfc.ccf-enterprise",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-enterprise.access"],
    },
    {
        id: "cfc.ccf-assessment",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-assessment.access"],
    },
    {
        id: "cfc.ccf-employee-commuting-survey",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-employee-commuting-survey.access"],
    },
    {
        id: "cfc.ccf-csrd",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-csrd.access"],
    },
    {
        id: "transparency-dashboard-frontend",
        url: "http://localhost:3000",
        permissionKeys: ["transparency-dashboard-frontend.access"],
    },
    {
        id: "reduction-homepage-frontend",
        url: "https://reduction-homepage-frontend-staging.smart-staging.c12r.io",
        permissionKeys: [],
    },
    {
        id: "analytics.basic",
        url: "http://localhost:5178",
        permissionKeys: ["analytics.basic.access"],
    },
];
const prodServices = [
    {
        id: "fpm",
        url: "https://fpm.climatepartner.com",
        permissionKeys: ["fpm.access"],
    },
    {
        id: "fpc",
        url: "https://calc.climatepartner.com",
        permissionKeys: ["fpc.access"],
    },
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKeys: [],
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-supplier.access"],
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKeys: ["network-purchaser.access"],
    },
    {
        id: "cfc",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.access"],
    },
    {
        id: "cfc.ccf-basic",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-basic.access"],
    },
    {
        id: "cfc.ccf-enterprise",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-enterprise.access"],
    },
    {
        id: "cfc.ccf-assessment",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-assessment.access"],
    },
    {
        id: "cfc.ccf-employee-commuting-survey",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-employee-commuting-survey.access"],
    },
    {
        id: "cfc.ccf-csrd",
        url: "https://calculation.climatepartner.com",
        permissionKeys: ["cfc.ccf-csrd.access"],
    },
    {
        id: "transparency-dashboard-frontend",
        url: "https://transparency.climatepartner.com",
        permissionKeys: ["transparency-dashboard-frontend.access"],
    },
    {
        id: "reduction-homepage-frontend",
        url: "https://reduction.climatepartner.com",
        permissionKeys: [],
    },
    {
        id: "analytics.basic",
        url: "https://analytics.climatepartner.com",
        permissionKeys: ["analytics.basic.access"],
    },
    {
        id: "transparency.reports",
        url: "https://transparency.climatepartner.com/en/reports",
        permissionKeys: ["cfc.ccf-csrd.access", "cphub.employee.access"],
    },
];
const mapEnvironmentToServices = (environment) => {
    switch (environment) {
        case "dev":
            return devServices;
        case "staging":
            return stagingServices;
        case "prod":
            return prodServices;
        default:
            throw new Error("Invalid environment");
    }
};
export const getServiceUrls = ({ env, userHasPermission, }) => {
    const serviceUrls = mapEnvironmentToServices(env);
    if (!userHasPermission) {
        return serviceUrls.map(({ id, url }) => ({
            id,
            url,
        }));
    }
    const serviceUrlsWithAccess = serviceUrls.map(({ id, url, permissionKeys }) => ({
        id,
        url,
        userHasAccess: permissionKeys.every(userHasPermission),
    }));
    const isNetworkSupplier = serviceUrlsWithAccess.find(({ id }) => id === "network-supplier")?.userHasAccess === true;
    // This is based on https://climatepartner.atlassian.net/browse/RED-945.
    // Prospective customers are not supposed to have access to reductions. The
    // closest we can get to this, given just the information contained in the
    // token, is checking for `network-supplier`.
    if (isNetworkSupplier) {
        return serviceUrlsWithAccess.map((service) => {
            const { id } = service;
            if (id === "reduction-homepage-frontend") {
                return { ...service, userHasAccess: false };
            }
            return service;
        });
    }
    return serviceUrlsWithAccess;
};
//# sourceMappingURL=getServiceUrls.js.map